import axios from "../axios/AxiosInstance";

export async function loadFreelanceInvoices() {
  const { data } = await axios.get("facture/freelance-to-agency");
  const rows = Array.isArray(data)
    ? data
    : (data?.invoices ?? data?.factures ?? data?.data);
  if (Array.isArray(rows)) return rows;
  throw new Error("Format de réponse du suivi des factures non reconnu.");
}
export function freelanceInvoiceError(error) {
  const status = error.response?.status;
  if (status === 404 || status === 501)
    return "Le suivi des paiements n’est pas encore disponible sur le serveur de l’agence. Vos dépôts locaux restent accessibles.";
  if (status === 401)
    return "Votre session a expiré. Reconnectez-vous pour consulter le suivi de l’agence.";
  if (status === 403)
    return "Votre compte n’est pas autorisé à consulter ce suivi. Contactez l’agence.";
  if (
    !error.response &&
    error.message === "Format de réponse du suivi des factures non reconnu."
  )
    return error.message;
  if (!error.response)
    return "Connexion au serveur de l’agence impossible. Vérifiez votre connexion puis actualisez.";
  return `Le serveur de l’agence ne peut pas charger le suivi (erreur ${status}). Réessayez plus tard.`;
}
